(($, Drupal) => {
  Drupal.behaviors.togglable_copyrights = {
    attach(context) {
      const togglableCopyrights = once(
        "togglable_copyrights",
        ".copyright--image.togglable",
        context
      );
      togglableCopyrights.forEach((copyright) => {
        copyright.addEventListener("click", (e) => {
          e.stopPropagation();
        });
        const copyrightTextElement =
          copyright.querySelector(".copyright--text");
        copyright.addEventListener("click", (event) => {
          copyrightTextElement.classList.toggle("expanded");
        });
        copyright.addEventListener("transitionstart", (e) => {
          if (!e.target.classList.contains("expanded")) {
            e.target.classList.add("no-text-wrap");
            e.target.classList.remove("text-wrap");
          }
        });
        copyright.addEventListener("transitionend", (e) => {
          if (e.target.classList.contains("expanded")) {
            e.target.classList.add("text-wrap");
            e.target.classList.remove("no-text-wrap");
          } else {
            e.target.classList.add("no-text-wrap");
            e.target.classList.remove("text-wrap");
          }
        });
      });
    },
  };

  $(document).on("geofieldMapInit", function (e, mapid) {
    const { map } = Drupal.geoFieldMapFormatter.map_data[mapid];
    // eslint-disable-next-line no-undef
    google.maps.event.addListener(map.infowindow, "domready", function () {
      Drupal.attachBehaviors(document, Drupal.settings);
    });
  });
})(jQuery, Drupal);
